var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRequestOrange(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.49658 13.5003V6.49734C3.49658 4.83965 4.84014 3.49609 6.49783 3.49609H18.5028C20.1605 3.49609 21.5041 4.83965 21.5041 6.49734V18.5023C21.5041 20.16 20.1605 21.5036 18.5028 21.5036H12.5003",
    stroke: "#F4904D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.187 11.7812L13.1688 13.763L16.002 10.9959C16.039 10.9598 16.1011 10.9719 16.1231 11.0179C16.8564 12.5855 16.5132 14.5163 15.2177 15.8109C13.9632 17.0654 12.1794 17.3955 10.6598 16.8013L6.48705 20.974C5.80277 21.6573 4.69331 21.6573 4.01002 20.974C3.32674 20.2897 3.32674 19.1803 4.01002 18.497L8.14975 14.3573C7.5545 12.8386 7.88564 11.0549 9.14016 9.79937C10.4327 8.50683 12.3595 8.22571 13.9282 8.89699C13.9752 8.918 13.9872 8.98203 13.9512 9.01904L11.187 11.7812Z",
    stroke: "#F4904D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequestOrange);
export default __webpack_public_path__ + "static/media/request-orange.1697e0d9fbd9e8cfd8f9ffc921e1aad6.svg";
export { ForwardRef as ReactComponent };